import { UpsellPageConfig } from 'server/types/pmts-overrides';
import { StripeAddress } from 'shared/payments/types';
import { PageShell } from '../campaign/campaign-page-shell';
import { SectionRenderer } from '../campaign/section-renderer';

type Props = {
  config: UpsellPageConfig;
  courseTitle: string;
  acceptText: string;
  declineText: string;
  onAccept(paymentMethodId?: string, address?: StripeAddress): void;
  onDecline(): void;
  isProcessing: boolean;
  cardInfo?: { last4: string; brand: string };
  priceId?: string;
  trialDays?: number;
  priceDisplay?: string;
  amount?: number;
  currency?: string;
  paymentType?: string;
  brand?: string;
};

export function CustomUpsellPage(props: Props) {
  return (
    <PageShell docTitle={[props.courseTitle, 'Special Offer']} brand={props.brand}>
      <SectionRenderer
        sections={props.config}
        brand={props.brand}
        upsellProps={{
          onAccept: props.onAccept,
          onDecline: props.onDecline,
          isProcessing: props.isProcessing,
          cardInfo: props.cardInfo,
          priceId: props.priceId,
          trialDays: props.trialDays,
          priceDisplay: props.priceDisplay,
          amount: props.amount,
          currency: props.currency,
          paymentType: props.paymentType,
        }}
      />
    </PageShell>
  );
}
